import { SECTION_SLOGANS, SECTION_TITLES } from '@/constants/products';
import SectionTitle from '../common/SectionTitle';
import FeaturedProductSection from './FeaturedProductSection';

import { PATH } from '@/constants/path';
import useNewProductsQuery from '@/hooks/RQHooks/market/new/useNewProductsQuery';
import FeaturedSectionSkeleton from '../../../../components/common/FeaturedSectionSkeleton';

const NewProductSection = () => {
  const { data, isPending } = useNewProductsQuery();

  return (
    <div>
      <SectionTitle
        title={SECTION_TITLES.NEW_PRODUCTS}
        slogan={SECTION_SLOGANS.NEW_PRODUCTS}
        link={PATH.CATEGORY.NEW}
      />
      {isPending ? <FeaturedSectionSkeleton /> : <FeaturedProductSection data={data ?? []} isNew />}
    </div>
  );
};

export default NewProductSection;
